module.exports = __webpack_public_path__ + "img/nft_logo.16306e58.png";